<div class="dialog-agent">
  <h1 mat-dialog-title>{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.UPLOAD-CERT' | translate }}</h1>
  <div mat-dialog-content class="">
    <div class="dialog-tab-content w-100">
      <div class="row m-0 w-100">
        <div class="col-12 col-lg-12 float-start py-3">
          <mat-label class="w-100 d-block pb-1 h6">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.UPLOAD-CERT' | translate }}</mat-label>
          <mat-form-field
            tabindex="0"
            [ngClass]="{'mat-focused': uploadIsFocus}"
            (keyup.enter)="certCustomFile.click()"
            (keyup.space)="certCustomFile.click()"
            (focus)="uploadIsFocus = true"
            (blur)="uploadIsFocus = false"
            class="w-100 pointer fake-file-click"
            (click)="certCustomFile.click()"
            dndDropzone
            [dndAllowExternal]="true"
            (dndDrop)="styleCustomImageFile.value = $event.event.dataTransfer.files[0]?.name; onFile1Drop($event);">
            <input matInput readonly required [placeholder]="'GLOBAL.SELECT-FILE' | translate" class="pointer" disabled #styleCustomImageFile>
            <i matSuffix *ngIf="certCustomFile.value || file1Droped" (click)="styleCustomImageFile.value = ''; file1Droped = false;" title="Remove" class="rt-icon rt-cerrar pointer fs18 me-2 zUp"></i>
            <i matSuffix *ngIf="!(certCustomFile.value || file1Droped)" class="rt-icon rt-archivo pointer fs22 mx-1"></i>
            <mat-hint class="text-danger animated fadeInDown" *ngIf="!(data.fileUpload)">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
          </mat-form-field>
          <input hidden type="file" accept=".pfx, .p12" #certCustomFile (change)="styleCustomImageFile.value = $event.target.files[0]?.name; data.fileUpload =  $event.target.files[0]; fileSizeValidate(styleCustomImageFile, certCustomFile, $event);"/>
        </div>

        <div class="col-12 col-lg-12 float-start py-3">
          <mat-label class="w-100 d-block pb-1 h6">{{ 'CERTIFICATES.TABS.PRIVATE.LABELS.PASSWORD-CERT' | translate }}</mat-label>
          <mat-form-field class="w-100">
            <input matInput [placeholder]="'CERTIFICATES.TABS.PRIVATE.LABELS.INSERT-CERTIFICATE-PASS' | translate" [type]="hide ? 'password' : 'text'" #toPassword="ngModel" [(ngModel)]="data.toPassword" required autocomplete="new-password">
            <i class="rt-icon pointer fs22 mx-2" matSuffix [attr.data-selenium]="'toggle-cert-password'" (click)="hide = !hide" [ngClass]="{'rt-view': hide, 'rt-hide': !hide}"></i>
            <mat-hint class="text-danger animated fadeInDown" *ngIf="toPassword.errors && toPassword.errors.required">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-12 float-start py-3">
          <mat-label class="w-100 d-block pb-1 h6">
            {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.CERT-PIN' | translate }} <small class="font-italic text-secondary">({{ 'GLOBAL.OPTIONAL' | translate }})</small>
          </mat-label>
          <mat-form-field class="w-100">
            <input matInput [placeholder]="'CERTIFICATES.TABS.PRIVATE.LABELS.INSERT-CERTIFICATE-PIN' | translate" [type]="hide2 ? 'password' : 'text'" #toPin="ngModel" [(ngModel)]="data.toPin" autocomplete="new-password">
            <i class="rt-icon pointer fs22 mx-2" matSuffix [attr.data-selenium]="'toggle-cert-password'" (click)="hide2 = !hide2" [ngClass]="{'rt-view': hide2, 'rt-hide': !hide2}"></i>
          </mat-form-field>
        </div>

      </div>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" (click)="sendData(data);" [disabled]="(sendingInfo) || !(data.fileUpload) || !(data.toPassword)" type="button">
      <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="sendingInfo"></i>
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.UPLOAD' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" [disabled]="sendingInfo" (click)="cancelChanges()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
